export class DownloadGroup {
  partnerId: number;
  enterpriseId: number;
  number: number;
  beginIndex: number;
  endIndex: number;
  size: number;
  groupSize: number;
}
